import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { HomeScriptComponent } from './auth/home-script/home-script.component';
import { NotAuthGuardService } from './auth/not-auth-guard.service';
import { AuthGuardService } from './auth/auth-guard.service';

const appRoutes: Routes = [
  { path: '', component: HomeScriptComponent, canActivate: [NotAuthGuardService] },
  // tslint:disable-next-line: max-line-length
  { path: '', loadChildren: () => import('./manufacturer/manufacturer.module').then(m => m.ManufacturerModule), canActivate: [AuthGuardService]},
  // tslint:disable-next-line: max-line-length
  { path: '', loadChildren: () => import('./super-admin/super-admin.module').then(m => m.SuperAdminModule), canActivate: [AuthGuardService]},
  { path: '', loadChildren: () => import('./product/product.module').then(m => m.ProductModule), canActivate: [AuthGuardService]},
  // tslint:disable-next-line: max-line-length
  { path: '', loadChildren: () => import('./distributor/distributor.module').then(m => m.DistributorModule), canActivate: [AuthGuardService]},
  // tslint:disable-next-line: max-line-length
  { path: '', loadChildren: () => import('./company-profile/company-profile.module').then(m => m.CompanyProfileModule), canActivate: [AuthGuardService]},
  // tslint:disable-next-line: max-line-length
  { path: '', loadChildren: () => import('./super-admin-pendings/super-admin-pendings.module').then(m => m.SuperAdminPendingsModule), canActivate: [AuthGuardService]},
  { path: '', loadChildren: () => import('./statistics/statistics.module').then(m => m.StatisticsModule), canActivate: [AuthGuardService]},
  {
    path: '**',
    redirectTo: '',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules })
  ],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule { }

